import { QueryClient } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { router } from '../routes'

export const App = () => {
  return <RouterProvider router={router} />
}

// eslint-disable-next-line react-refresh/only-export-components
export const queryClient = new QueryClient({
  // defaultOptions: {
  //   queries: {
  //     refetchOnWindowFocus: false,
  //   },
  // },
  //   queryCache: new QueryCache({
  //     onError: (error, query) => {
  //       // if (error) handleError(query?.state?.error?.message)
  //     },
  //   }),
  //   mutationCache: new MutationCache({
  //     onError: (error) => {
  //       // if (error) handleError(JSON.stringify(error))
  //     },
  //   }),
})

export type QueryClientType = typeof queryClient

// This code is only for TypeScript
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient
  }
}

// This code is for all users
window.__TANSTACK_QUERY_CLIENT__ = queryClient
